import {
  Box,
  Button,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  TableContainer,
  Text,
  Flex,
  Select,
  Icon,
  Td,
  Menu,
  MenuButton,
  IconButton,
  MenuItem,
  MenuList,
  Spinner,
  Tooltip,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  Switch,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import {
  FaCheck,
  FaExclamation,
  FaEye,
  FaFileExport,
  FaLink,
  FaPlay,
  FaTimes,
  FaTrash,
  FaReceipt,
} from "react-icons/fa";
import { FiPlus } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import { useSetRecoilState, useRecoilState } from "recoil";
import moment from "moment";
import ModalTransferDetail from "./component/modalTransferDetail";
import { HamburgerIcon } from "@chakra-ui/icons";
import { toast } from "react-toastify";
import ModalDeleteConfirmation from "./component/modalDeleteConfirmation";
import { refreshGlobal } from "../../../atoms/refreshGlobal";
import {
  dateForAPI,
  dateForListWithHours,
} from "../../../constants/dataFormat";
import TransferApiNovo from "../../../services/transferApiNovo";
import { JWTToken } from "../../vendas/listaDeVendas/SalesList";
import jwt_decode from "jwt-decode";
import DateDropdown from "../../../defaultComponents/dateDropdown";
import { goToAddTransferSolicitationListNew } from "../../../routes/coordinator";
import {
  CNPJFormater,
  CPFFormater,
  CaptionFormater,
} from "../../../defaultFunctions/formaters";
import Pagination from "../../../defaultComponents/pagination";
import { baseURL } from "../../../services/api";
import md5 from "md5";
import ValueDropdown from "../../vendas/listaDeVendas/defaultComponent/valueDropdown";
import fileDownload from "js-file-download";
import { customColors } from "../../../atoms/customColors";

interface PaymentList {
  atualizadoEm: string;
  cliente: {
    ativo: boolean;
    cnpj: string;
    email: string;
    id: number;
    idPlano: number;
    idPromocao: number;
    isCnpj: boolean;
    nome: string;
    nomeFantasia: string;
    razaoSocial: string;
    sobrenome: string;
  };
  cnpjDestinatario: string;
  criadoEm: string;
  id: number;
  idCliente: number;
  idStatus: number;
  idTipoConta: number;
  nomeDestinatario: string;
  nroAgencia: string;
  nroAgenciaDigito: string;
  nroBanco: string;
  nroConta: string;
  nroContaDigito: string;
  observacao: string;
  status: {
    id: number;
    status: string;
  };
  tipoConta: any;
  transferenciaHistorico: [transferHistorico];
  valor: number;
}

interface transferHistorico {
  atualizadoEm: string;
  criadoEm: string;
  data: string;
  hora: string;
  id: number;
  idStatus: number;
  idTransferencia: number;
  observacao: string;
  status: any;
}

interface StatusTypes {
  [chave: string]: JSX.Element;
}

const statusTypes: StatusTypes = {
  Efetivado: <FaCheck />,
  Processando: <FaExclamation />,
  Pendente: <FaExclamation />,
  "Remessa Gerada": <FaExclamation />,
  "Não efetivado": <FaExclamation />,
  Cancelado: <FaTimes />,
};

export default function TransferSolicitatioNew() {
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(15);
  const [pages, setPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const [salesList, setSalesList] = useState(Array<PaymentList>);
  const [isOpen, setIsOpen] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const [openDetalhamento, setOpenDetalhamento] = useState(false);
  const colors = useRecoilState(customColors)[0];
  const refresh = useRecoilState(refreshGlobal)[0];
  const token = window.localStorage.getItem("token");
  let jwtToken: JWTToken = jwt_decode(token || "");
  const id = Number(jwtToken.idCliente);
  const idTipoUsuario = jwtToken.idTipoUsuario;
  const [paymentDetails, setPaymentDetails] = useState(
    Array<transferHistorico>
  );
  const initialValues = {
    clientFilter: 0,
    statusFilter: 0,
    saleTypeFilter: 0,
    initialDateFilter: moment().startOf("day").format(dateForAPI),
    finalDateFilter: moment().endOf("day").format(dateForAPI),
    minValueFilter: 0,
    maxValueFilter: 0,
  };
  const [filtros, setFiltros] = useState(initialValues);
  const [idTransfer, setIdTransfer] = useState(0);
  let dias =
    moment(filtros.finalDateFilter).diff(filtros.initialDateFilter, "days") >=
    32;
  const navigate = useNavigate();
  const [showManualFlag, setShowManualFlag] = useState(false);
  const [isManualActive, setIsManualActive] = useState(false);

  useEffect(() => {
    if (!token) {
      setShowManualFlag(false);
      return;
    }

    try {
      const decoded: JWTToken = jwt_decode(token);
      if (decoded.loginPermissoes) {
        try {
          const loginPermissoes: number[] = JSON.parse(decoded.loginPermissoes);
          const hasPermission41 = loginPermissoes.includes(41);
          setShowManualFlag(hasPermission41);
        } catch (parseError) {
          setShowManualFlag(false);
        }
      } else {
        setShowManualFlag(false);
      }
    } catch (error) {
      setShowManualFlag(false);
    }
  }, [token]);

  function formatDocumentNumber(number: any) {
    const unmaskedNumber = number.replace(/\D/g, "");
    if (number.includes("*")) {
      return number;
    }
    if (unmaskedNumber.length === 11) {
      return unmaskedNumber.replace(
        /(\d{3})(\d{3})(\d{3})(\d{2})/,
        "$1.$2.$3-$4"
      );
    } else if (unmaskedNumber.length === 14) {
      return unmaskedNumber.replace(
        /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
        "$1.$2.$3/$4-$5"
      );
    } else {
      return number;
    }
  }

  async function getPaymentList() {
    try {
      setLoading(true);
      const response = await TransferApiNovo.getTransferSolicitation(
        filtros.statusFilter,
        id,
        filtros.initialDateFilter,
        filtros.finalDateFilter,
        currentPage,
        pageSize,
        search,
        filtros.minValueFilter,
        filtros.maxValueFilter,
        showManualFlag && isManualActive
      );
      setSalesList(response.data);
      setPages(
        Math.ceil(Number(response.headers.totalamountofrecords) / pageSize)
      );
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  }

  const onChangeSize = (e: any) => {
    setPageSize(e.target.value);
    setCurrentPage(1);
  };

  const FuncaoChamarRotaCancelar = async (idTransfer: number) => {
    try {
      const obj = {};
      await getPaymentList();
    } catch (error) {
      console.error("Erro ao cancelar transferência:", error);
    }
  };

  async function Export() {
    try {
      setLoading(true);
      const response = await TransferApiNovo.exportTransferencia(
        filtros.statusFilter,
        filtros.minValueFilter,
        filtros.maxValueFilter,
        filtros.initialDateFilter,
        filtros.finalDateFilter,
        Number(jwtToken.idCliente),
        ""
      );
      fileDownload(response, "transferencias.xlsx");
      setLoading(false);
    } catch (error) {
      setLoading(false);
      toast.error("Não foi possível exportar o arquivo!");
    }
  }

  useEffect(() => {
    if (currentPage > pages) {
      setCurrentPage(1);
      getPaymentList();
    }
  }, [pages]);

  useEffect(() => {
    getPaymentList();
  }, [
    search,
    currentPage,
    pageSize,
    refresh,
    filtros.initialDateFilter,
    filtros.finalDateFilter,
    filtros.clientFilter,
    filtros.minValueFilter,
    filtros.maxValueFilter,
    filtros.statusFilter,
    isManualActive,
  ]);

  const arrayDeStatus = [
    { id: 1, status: "Pendente" },
    { id: 2, status: "Remessa Gerada" },
    { id: 3, status: "Processando" },
    { id: 4, status: "Efetivado" },
    { id: 5, status: "Cancelado" },
    { id: 6, status: "Não Efetivado" },
  ];

  function onChangeStatusFilter(e: any) {
    setFiltros({ ...filtros, statusFilter: Number(e.target.value) });
  }

  const statusOptions =
    arrayDeStatus &&
    arrayDeStatus.map((item) => {
      return {
        key: item.id,
        value: item.id,
        text: item.status,
      };
    });

  return (
    <Flex flexDir={"column"} height="100%" width="100%" bgColor={colors.WHITE}>
      <Box
        width={"100%"}
        height={"fit-content"}
        mt={"0.3%"}
        mx="auto"
        py={3}
        px={3}
      >
        <Flex px={8} py={3} alignItems="center">
          <FaPlay color={colors.BLUEMONEDDBUTTONS} size="25px" />
          <Text
            mx={4}
            color={colors.BLUEMONEDDBUTTONS}
            fontSize={35}
            fontWeight={"bold"}
          >
            Transferências PIX
          </Text>
        </Flex>
      </Box>
      <Flex
        width={"100%"}
        height={"fit-content"}
        mt={"0.1%"}
        mx="auto"
        py={3}
        px={10}
        flexDirection={"column"}
      >
        <Text mb={2} fontWeight={"bold"}>
          Filtros
        </Text>

        <Flex width={"100%"} height={"100%"} justifyContent="space-evenly">
          <DateDropdown filtros={filtros} setFiltros={setFiltros} />
          <ValueDropdown filtros={filtros} setFiltros={setFiltros} />
          <Select
            fontSize={"0.8rem"}
            placeholder="Filtrar por Status"
            maxW={"14%"}
            value={filtros.statusFilter}
            onChange={onChangeStatusFilter}
          >
            {statusOptions.map((item) => (
              <option value={item.value} key={item.key}>
                {item.text}
              </option>
            ))}
          </Select>
          {showManualFlag && (
            <Flex
              alignItems="center"
              bgColor={colors.WHITE}
              p={2}
              borderRadius="md"
            >
              <Switch
                isChecked={isManualActive}
                onChange={(e) => setIsManualActive(e.target.checked)}
                colorScheme="blue"
                mr={2}
                size="md"
              />
              <Text>Mostrar Transferências Manuais</Text>
            </Flex>
          )}
          <Button
            bgColor={colors.GRAY_NEUTRAL}
            color={colors.WHITE}
            onClick={() => {
              setFiltros(initialValues);
              setIsManualActive(false);
            }}
          >
            Limpar Filtros
          </Button>
          <Button
            bg={"none"}
            color={colors.BLUEMONEDDBUTTONS}
            isDisabled={loading || dias}
            onClick={() => {
              Export();
            }}
            mx="10px"
            isLoading={loading}
            textTransform={"uppercase"}
            leftIcon={<FaFileExport />}
          >
            <Text fontSize={"0.8rem"}>Exportar</Text>
          </Button>
          {(idTipoUsuario === "1" ||
            idTipoUsuario === null ||
            idTipoUsuario === "") && (
            <Button
              bgColor={colors.BLUEMONEDDBUTTONS}
              color={colors.WHITE}
              onClick={() => {
                goToAddTransferSolicitationListNew(navigate);
              }}
            >
              <Icon mr={2} as={FiPlus} />
              Nova Transferência
            </Button>
          )}
        </Flex>
      </Flex>

      {loading ? (
        <Flex
          width={"100%"}
          height={"80vh"}
          mt={"0.1%"}
          justifyContent={"center"}
          alignItems={"center"}
          mx="auto"
          py={3}
          px={10}
          overflowY="scroll"
        >
          <Spinner size={"lg"} color={colors.VARIANT} />
        </Flex>
      ) : (
        <Box
          width={"100%"}
          height={"80vh"}
          mt={"0.1%"}
          mx="auto"
          py={3}
          px={10}
          overflowY="scroll"
        >
          <TableContainer>
            <Table variant="striped" colorScheme="blue" size="sm">
              <Thead h="60px" position="sticky" top="0">
                <Tr>
                  <Th
                    w={"300px"}
                    borderRadius={"8px 0 0 8px"}
                    textAlign={"center"}
                    bgColor={colors.BLUEMONEDDBUTTONS}
                    color={colors.WHITE}
                  >
                    Data da Envio
                  </Th>
                  <Th
                    w={"300px"}
                    textAlign={"center"}
                    bgColor={colors.BLUEMONEDDBUTTONS}
                    color={colors.WHITE}
                  >
                    Destinatário
                  </Th>
                  <Th
                    w={"300px"}
                    textAlign={"center"}
                    bgColor={colors.BLUEMONEDDBUTTONS}
                    color={colors.WHITE}
                  >
                    CPF/CNPJ do Destinatário
                  </Th>
                  <Th
                    w={"300px"}
                    textAlign={"center"}
                    bgColor={colors.BLUEMONEDDBUTTONS}
                    color={colors.WHITE}
                  >
                    Conta
                  </Th>
                  <Th
                    w={"300px"}
                    textAlign={"center"}
                    bgColor={colors.BLUEMONEDDBUTTONS}
                    color={colors.WHITE}
                  >
                    Valor a Pagar
                  </Th>
                  <Th
                    w={"300px"}
                    textAlign={"center"}
                    bgColor={colors.BLUEMONEDDBUTTONS}
                    color={colors.WHITE}
                  >
                    Situação
                  </Th>
                  <Th
                    w={"300px"}
                    textAlign={"center"}
                    bgColor={colors.BLUEMONEDDBUTTONS}
                    color={colors.WHITE}
                  >
                    Observação
                  </Th>
                  <Th
                    w={"300px"}
                    borderRadius={"0 8px 8px 0"}
                    textAlign={"center"}
                    bgColor={colors.BLUEMONEDDBUTTONS}
                    color={colors.WHITE}
                  >
                    Opções
                  </Th>
                </Tr>
              </Thead>
              <Tbody>
                {salesList &&
                  salesList.map((item: any, index: any) => (
                    <Tr key={index} onClick={() => {}}>
                      <Td fontSize={"13px"}>
                        {moment(item.criadoEm).format(dateForListWithHours)}
                      </Td>
                      <Td>{item.nomeDestinatario}</Td>
                      <Td fontSize={"13px"}>
                        {formatDocumentNumber(item.cnpjDestinatario)}
                      </Td>
                      <Td>
                        <Flex flexDirection={"column"}>
                          <Text>
                            Titular:{" "}
                            {item.nomeDestinatario
                              ? CaptionFormater(item.nomeDestinatario)
                              : ""}
                          </Text>
                          <Text>
                            CNPJ/CPF:{" "}
                            {item.cnpjDestinatario.includes("*")
                              ? item.cnpjDestinatario
                              : item.cnpjDestinatario.length === 14
                              ? CNPJFormater(item.cnpjDestinatario)
                              : CPFFormater(item.cnpjDestinatario)}
                          </Text>
                          <Text>
                            <>Pix por {item.tipoPix}</>
                          </Text>
                          <Text>
                            {item.tipoPix == "CHAVE" && (
                              <>
                                Tipo de Chave:{" "}
                                {item.tipoChave === "EVP"
                                  ? "EVP (CHAVE ALEATÓRIA)"
                                  : item.tipoChave}
                              </>
                            )}
                          </Text>
                          <Text>{<>Banco: {item.nroBanco}</>}</Text>
                          <Text>
                            {item.tipoPix == "CHAVE" ? (
                              `Chave Pix: ${item.chavePix}`
                            ) : (
                              <>
                                Agencia: {item.nroAgencia}{" "}
                                {item.nroAgenciaDigito
                                  ? `-${item.nroAgenciaDigito}`
                                  : ""}
                                - Conta:{" "}
                                {item.nroContaDigito
                                  ? `${item.nroConta}-${item.nroContaDigito}`
                                  : item.nroConta}
                              </>
                            )}
                          </Text>
                          <Text>
                            {item.chave !== null ? (
                              <></>
                            ) : (
                              <>
                                Banco: {item.nroBanco} -{" "}
                                {item.idTipoConta === 1
                                  ? "Corrente"
                                  : "Poupança"}
                              </>
                            )}
                          </Text>
                        </Flex>
                      </Td>
                      <Td>
                        {item.valor.toLocaleString("pt-BR", {
                          style: "currency",
                          currency: "BRL",
                        })}
                      </Td>
                      {item.status.status === "Não efetivado" ? (
                        <Td>
                          <Tooltip
                            label={
                              item.transferenciasHistorico[
                                item.transferenciasHistorico.length - 1
                              ].observacao
                            }
                            hasArrow
                            bg={colors.ORANGEMONEDD}
                            color="white"
                            placement="auto-start"
                          >
                            {item.status.status}
                          </Tooltip>
                        </Td>
                      ) : (
                        <Td>{item.status.status}</Td>
                      )}
                      <Td>{item.observacao ? item.observacao : "N/A"}</Td>
                      <Td>
                        <Menu>
                          <MenuButton
                            as={IconButton}
                            aria-label="Options"
                            icon={<HamburgerIcon />}
                            bgColor={colors.VARIANT}
                            color={colors.WHITE}
                            size={"sm"}
                          />
                          <MenuList>
                            <MenuItem
                              icon={<FaEye />}
                              onClick={() => {
                                setIsOpen(true);
                                setPaymentDetails(item.transferenciasHistorico);
                              }}
                            >
                              Visualizar Histórico
                            </MenuItem>
                            {item.idStatus === 4 && (
                              <MenuItem
                                icon={<FaReceipt />}
                                onClick={() => {
                                  window.open(
                                    `${baseURL}/Comprovante/Transferencia/${
                                      item.chave
                                    }?secret=${md5(item.id)}`,
                                    "_blank"
                                  );
                                }}
                              >
                                Visualizar Recibo
                              </MenuItem>
                            )}
                          </MenuList>
                        </Menu>
                      </Td>
                    </Tr>
                  ))}
              </Tbody>
            </Table>
          </TableContainer>
          <ModalTransferDetail
            isOpen={isOpen}
            setIsOpen={setIsOpen}
            item={paymentDetails}
          />
          <ModalDeleteConfirmation
            isOpen={openDelete}
            setIsOpen={setOpenDelete}
            getTransferList={getPaymentList}
            id={idTransfer}
          />
          <Flex width={"100%"} justifyContent="center" mt={8}>
            <Pagination
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              pages={pages}
              pageSize={pageSize}
            />
            <Select
              value={pageSize}
              onChange={onChangeSize}
              size="sm"
              ml={5}
              maxW="70px"
              borderRadius="6px"
            >
              <option value={5}>5</option>
              <option value={10}>15</option>
              <option value={15}>15</option>
              <option value={25}>25</option>
            </Select>
          </Flex>
        </Box>
      )}
    </Flex>
  );
}
